export default {"src":"/_next/static/media/IMG_9291.06d67ae3.JPG","height":1481,"width":2222};